import { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import './App.css';

// Anon key (same as the mobile apps) — admin access is enforced by
// is_admin() RLS policies, not by key privilege. Never put the
// service-role key in this file: it ships in the public bundle.
const supabase = createClient(
  'https://zifhuekyaqltvrqgstco.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InppZmh1ZWt5YXFsdHZycWdzdGNvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzMzQ3NDgsImV4cCI6MjA4OTkxMDc0OH0.nnm-PVjXyAxtRl3HrmJKGw0AhvDGLO-NeQ39fc19FXk'
);

export { supabase };

function Splash() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "#000" }}>
      <div style={{ color: "#00A651", fontSize: 24, fontWeight: "bold" }}>KargoSL Admin</div>
    </div>
  );
}

function NotAuthorized() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, justifyContent: "center", alignItems: "center", height: "100vh", background: "#000" }}>
      <div style={{ color: "#e74c3c", fontSize: 20, fontWeight: "bold" }}>Not authorized</div>
      <div style={{ color: "#666", fontSize: 14, maxWidth: 360, textAlign: "center" }}>
        This account does not have admin access to the KargoSL operations dashboard.
      </div>
      <button
        style={{ background: "#00A651", color: "#fff", border: "none", borderRadius: 8, padding: "10px 24px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
        onClick={() => supabase.auth.signOut()}>
        Sign out
      </button>
    </div>
  );
}

function App() {
  const [session, setSession] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!session) { setIsAdmin(null); return; }
    supabase.from('profiles').select('is_admin').eq('id', session.user.id).single()
      .then(({ data }) => setIsAdmin(data?.is_admin === true));
  }, [session]);

  if (loading) return <Splash />;
  if (!session) return <Login supabase={supabase} />;
  if (isAdmin === null) return <Splash />;
  if (!isAdmin) return <NotAuthorized />;
  return <Dashboard supabase={supabase} session={session} />;
}

export default App;
